var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"container"}},[_c('div',{staticClass:"msection-wrap"},[_c('eng-main-info-video')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }